var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.1094 0.9375H1.89062C0.984521 0.9375 0.25 1.67202 0.25 2.57812V12.4219C0.25 13.328 0.984521 14.0625 1.89062 14.0625H16.1094C17.0155 14.0625 17.75 13.328 17.75 12.4219V2.57812C17.75 1.67202 17.0155 0.9375 16.1094 0.9375ZM16.1094 2.57812V3.97283C15.343 4.59691 14.1212 5.56734 11.5092 7.61262C10.9336 8.0654 9.79338 9.15317 9 9.14049C8.20676 9.15331 7.06615 8.06523 6.49077 7.61262C3.8792 5.56765 2.6571 4.59702 1.89062 3.97283V2.57812H16.1094ZM1.89062 12.4219V6.07806C2.67382 6.70187 3.78449 7.57725 5.47737 8.90287C6.22444 9.49093 7.53273 10.7891 9 10.7812C10.4601 10.7891 11.7518 9.50977 12.5223 8.90314C14.2152 7.57755 15.3261 6.70194 16.1094 6.07809V12.4219H1.89062Z","fill":"currentColor"}));
}

EmailInline.defaultProps = {"width":"18","height":"15","viewBox":"0 0 18 15","fill":"none"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
